import React from 'react';

function BookingTable({
  bookings, selectedBookings, formatDate, formatPrice,
  onCheckboxChange, onSelectAll, onEditBooking, onCreateContact,
  onSendInvoiceEmail, onOfferWaitlistSpot, onCancelBooking, onUpdateAttendance,
  currentPage, totalPages, totalCount, onPageChange
}) {
  return (
    <>
      <div className="bookings-table">
        <table>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={selectedBookings.length === bookings.length && bookings.length > 0}
                  onChange={onSelectAll}
                />
              </th>
              <th>Namn</th>
              <th>Företag</th>
              <th>E-post</th>
              <th>Kurs</th>
              <th>Datum</th>
              <th>Pris</th>
              <th>Status</th>
              <th>Närvaro</th>
              <th>Åtgärder</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map(booking => (
              <tr key={booking.id} className={`booking-row ${booking.status.toLowerCase()}`}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedBookings.includes(booking.id)}
                    onChange={() => onCheckboxChange(booking.id)}
                  />
                </td>
                <td>
                  <strong>{booking.participantFirstName} {booking.participantLastName}</strong>
                  {booking.specialDiet && (
                    <span className="diet-info" title={booking.specialDiet}>🍽️</span>
                  )}
                </td>
                <td>{booking.company}</td>
                <td>{booking.participantEmail}</td>
                <td>{booking.courseInstance.course.name}</td>
                <td>{formatDate(booking.courseInstance.startDate)}</td>
                <td>
                  {formatPrice(booking.price)}
                  {booking.discount > 0 && (
                    <span className="discount-badge">-{booking.discount}%</span>
                  )}
                </td>
                <td>
                  <span className={`status-badge ${booking.status.toLowerCase()}`}>
                    {booking.status === 'Confirmed' && '✅ Bekräftad'}
                    {booking.status === 'Waitlist' && `⏳ Väntelista #${booking.waitlistPosition}`}
                    {booking.status === 'Cancelled' && '❌ Avbokad'}
                  </span>
                </td>
                <td>
                  {booking.status === 'Confirmed' && (
                    <div className="attendance-cell">
                      <select
                        value={booking.attended === true ? 'true' : booking.attended === false ? 'false' : ''}
                        onChange={(e) => onUpdateAttendance(booking.id, e.target.value)}
                        className="attendance-select"
                        title="Om kursen är låst skickas diplom-mejl direkt när du sätter Närvarande. Innan låsning: använd närvarolänken läraren får per mejl (eller 'Lås närvaro' på kurstillfället)."
                      >
                        <option value="">-</option>
                        <option value="true">✅ Närvarande</option>
                        <option value="false">❌ Frånvarande</option>
                      </select>
                      <span
                        className="attendance-hint"
                        title="Om kursen är låst skickas diplom-mejl automatiskt när du sätter Närvarande (sent ankommen deltagare). Innan låsning sker inget mejl-utskick härifrån."
                      >ⓘ</span>
                    </div>
                  )}
                </td>
                <td>
                  <div className="action-buttons">
                    <button className="btn btn-small" onClick={() => onEditBooking(booking)} title="Redigera bokning">
                      ✏️
                    </button>
                    <button className="btn btn-small" onClick={() => onCreateContact(booking)} title="Skapa kontakt i CRM">
                      👤
                    </button>
                    {booking.status === 'Confirmed' && (
                      <button
                        className={`btn btn-small ${booking.invoiceEmailSentAt ? 'btn-success' : ''}`}
                        onClick={() => onSendInvoiceEmail(booking)}
                        title={booking.invoiceEmailSentAt
                          ? `Fakturamejl skickat ${new Date(booking.invoiceEmailSentAt).toLocaleDateString('sv-SE')}`
                          : 'Skicka fakturamejl'}
                      >
                        {booking.invoiceEmailSentAt ? '✅🧾' : '🧾'}
                      </button>
                    )}
                    {booking.status === 'Waitlist' && (
                      <button className="btn btn-small btn-primary" onClick={() => onOfferWaitlistSpot(booking)} title="Erbjud plats">
                        📧
                      </button>
                    )}
                    {booking.status !== 'Cancelled' && (
                      <button className="btn btn-small btn-danger" onClick={() => onCancelBooking(booking)} title="Avboka">
                        ❌
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button className="btn btn-small" onClick={() => onPageChange(1)} disabled={currentPage === 1}>
            &laquo; Första
          </button>
          <button className="btn btn-small" onClick={() => onPageChange(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>
            &lsaquo; Föregående
          </button>
          <span className="pagination-info">
            Sida {currentPage} av {totalPages} ({totalCount} bokningar)
          </span>
          <button className="btn btn-small" onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} disabled={currentPage === totalPages}>
            Nästa &rsaquo;
          </button>
          <button className="btn btn-small" onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
            Sista &raquo;
          </button>
        </div>
      )}
    </>
  );
}

export default BookingTable;
